import { useState } from 'react';
export interface ChatSuggestionsProps {
  suggestedQuestions: string[];
  setSuggestedQuestion: (question: string) => void;
  getSuggestionQuestions: () => void;
}
function ChatSuggestions({
  suggestedQuestions = [],
  setSuggestedQuestion
}: ChatSuggestionsProps) {
  const [questionClicked, setQuestionClicked] = useState<boolean>(false);
  return <div className="items-start flex flex-col gap-2.5 mb-6 mt-3" data-sentry-component="ChatSuggestions" data-sentry-source-file="suggestions.tsx">
      {suggestedQuestions.map((question: string, index: number) => <button className="text-[15px] cursor-pointer group select-none text-left rounded-md transition-all duration-300 flex gap-2 p-2 border border-foreground/10 hover:border-foreground/20 text-foreground/70 hover:text-foreground" onClick={e => {
      e.preventDefault();
      setQuestionClicked(true);
      setSuggestedQuestion(question);
    }} type="submit" disabled={questionClicked} key={index}>
          <span className="text-md text-foreground/40 font-bold transition-all duration-300 group-hover:text-foreground">
            ↳
          </span>
          {question}
        </button>)}
    </div>;
}
export default ChatSuggestions;